import { buildModelManager } from "../builder.js";
const DefaultFlowEdgeSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  isSourceFalseCondition: true,
  isSourceTrueCondition: true,
  scenarioId: true,
  sourceNodeId: true,
  targetNodeId: true,
  updatedAt: true
};
const modelApiIdentifier = "flowEdge";
const pluralModelApiIdentifier = "flowEdges";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultFlowEdgeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultFlowEdgeSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFlowEdgeSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFlowEdgeSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultFlowEdgeSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultFlowEdgeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultFlowEdgeSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findBySourceNode",
    findByField: "sourceNodeId",
    findByVariableName: "sourceNodeId",
    modelApiIdentifier,
    defaultSelection: DefaultFlowEdgeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindBySourceNode",
    findByField: "sourceNodeId",
    findByVariableName: "sourceNodeId",
    modelApiIdentifier,
    defaultSelection: DefaultFlowEdgeSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createFlowEdge",
    operationReturnType: "CreateFlowEdge",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { flowEdge: { required: false, type: "CreateFlowEdgeInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFlowEdgeSelection
  },
  {
    type: "action",
    operationName: "bulkCreateFlowEdges",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateFlowEdgesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultFlowEdgeSelection
  },
  {
    type: "action",
    operationName: "updateFlowEdge",
    operationReturnType: "UpdateFlowEdge",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      flowEdge: { required: false, type: "UpdateFlowEdgeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFlowEdgeSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateFlowEdges",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateFlowEdgesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultFlowEdgeSelection
  },
  {
    type: "action",
    operationName: "deleteFlowEdge",
    operationReturnType: "DeleteFlowEdge",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteFlowEdges",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertFlowEdge",
    operationReturnType: "UpsertFlowEdge",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      flowEdge: { required: false, type: "UpsertFlowEdgeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateFlowEdgeResult": { hasReturnType: false },
      "... on UpdateFlowEdgeResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultFlowEdgeSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertFlowEdges",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertFlowEdgesInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultFlowEdgeSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "flowEdgeGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const FlowEdgeManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultFlowEdgeSelection,
  operations
);
export {
  DefaultFlowEdgeSelection,
  FlowEdgeManager
};
//# sourceMappingURL=FlowEdge.js.map
